var SubscriptionsUI;

SubscriptionsUI = (function() {
  var DOI_DISMISS_LIFE_IN_SECONDS, TEN_YEARS_IN_SECONDS, USER_AGENTS, _is_sub_str, appName, constructionTime, currentDivision, isSubForced, loadCompleteTime, loadStartTime;

  TEN_YEARS_IN_SECONDS = 60 * 60 * 24 * 365 * 10;

  DOI_DISMISS_LIFE_IN_SECONDS = 60 * 60;

  appName = null;

  currentDivision = 'chicago';

  isSubForced = false;

  constructionTime = 0;

  loadStartTime = 0;

  loadCompleteTime = 0;

  USER_AGENTS = ['googlebot', 'bingbot', 'ask jeeves', 'yahoo! slurp', 'seoagent', 'AdsBot-Google', 'AdsBot-Google-Mobile', 'psbot', 'gosospider', 'sogou', 'google web preview', 'google wireless transcoder', 'mediapartners-google', 'baidu', 'gigabot', 'googlebot-image', 'libwww-perl', 'lwp-trivial', 'msnbot', 'siteuptime', 'slurp', 'teoma', 'uptakebot', 'voyager', 'wordpress', 'yahooseeker', 'zibb', 'zyborg', 'wget', 'curl'];

  SubscriptionsUI.increment_visited_cookie = function() {
    var subscription_last_visited, visited;
    visited = parseInt(Cookie.get("subscription_visited"));
    if (isNaN(visited)) {
      visited = 1;
    } else {
      ++visited;
    }
    subscription_last_visited = (new Date()).getTime();
    Cookie.set("subscription_visited", visited, TEN_YEARS_IN_SECONDS);
    return Cookie.set("subscription_last_visited", subscription_last_visited, TEN_YEARS_IN_SECONDS);
  };

  function SubscriptionsUI() {
    var now, ref, ref1;
    now = new Date();
    constructionTime = now.getTime();
    this.version = '2.7.2';
    if ((typeof Groupon !== "undefined" && Groupon !== null ? (ref = Groupon.division) != null ? ref.id : void 0 : void 0) != null) {
      currentDivision = Groupon.division.id;
    } else if (Cookie.get('division') != null) {
      currentDivision = Cookie.get('division');
    }
    appName = this._get_app_name();
    now = new Date();
    if (typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null) {
      if ((ref1 = OptimizeSuite.TrackingHub) != null) {
        if (typeof ref1.add === "function") {
          ref1.add("subscriptionUIdelegated", {
            goalType: "subscription",
            _useSDS: window._useSDS,
            totalLatency: now.getTime() - constructionTime
          });
        }
      }
    }
    isSubForced = window.location.href.indexOf('subs_force=') > -1;
    if (isSubForced && ((typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub : void 0) != null)) {
      OptimizeSuite.TrackingHub.add("subscriptionUIForced", {
        goalType: "subscription"
      });
    }
    if (!(window._useSDS || this._should_not_show_subsUI())) {
      this._show_subscribe_drawer();
    }
  }

  SubscriptionsUI.prototype._should_show_doi = function() {
    return (appName !== 'user_sessions' && appName !== 'itier/subscription_center' && appName !== 'sub_center') && !Cookie.get("subscription_doi_dismissed") && (Cookie.get("optin") || Cookie.get("optin_reminder"));
  };

  SubscriptionsUI.prototype._show_subscribe_drawer = function() {
    var divisionDropdown;
    if (!Cookie.get("close_subscribe_drawer")) {
      divisionDropdown = $('#subscribe-division');
      if (divisionDropdown.attr('data-options_decoded') === "false") {
        divisionDropdown.attr({
          'data-options_decoded': "true"
        });
        $("#subscribe-division > option").each(function() {
          var decodedName;
          decodedName = $(this).text().split("").reverse().join("");
          return $(this).text(decodedName);
        });
      }
      return $('#subscribe-drawer').show();
    }
  };

  SubscriptionsUI.prototype._user_has_sub_cookie = function() {
    var c, cookies, i, legacy_international_cookie, len;
    legacy_international_cookie = (typeof I18n !== "undefined" && I18n !== null ? I18n.country.toLowerCase() : void 0) + "_nl_subscribed";
    cookies = ["subscriber_email", "scid", "l", "user_id", "c", "snickerdoodle", "macaroon", legacy_international_cookie];
    for (i = 0, len = cookies.length; i < len; i++) {
      c = cookies[i];
      if (Cookie.get(c)) {
        return true;
      }
    }
    return false;
  };

  SubscriptionsUI.prototype._should_not_show_subsUI = function() {
    if (isSubForced) {
      return false;
    } else if (this._user_has_sub_cookie() || this._is_bot() || this._skip_subscription_ui() || this._is_email_click_traffic()) {
      return true;
    } else if (Cookie.get("hide_sub_modal") && this._should_hide_subscribe_drawer()) {
      return true;
    } else if (appName === 'user_sessions') {
      return true;
    } else {
      return false;
    }
  };

  SubscriptionsUI.prototype._should_hide_subscribe_drawer = function() {
    var no_drawer;
    no_drawer = Cookie.get("close_subscribe_drawer") || Cookie.get("hide_sub_banner");
    if (no_drawer) {
      return true;
    }
    if ((typeof subscriptionsUI_hideSubscribeDrawer !== "undefined" && subscriptionsUI_hideSubscribeDrawer !== null) && subscriptionsUI_hideSubscribeDrawer) {
      if (appName === 'pull' || appName === 'gsm-ita') {
        return false;
      } else {
        return true;
      }
    }
  };

  SubscriptionsUI.prototype._is_email_click_traffic = function() {
    var utm_medium;
    utm_medium = new RegExp('[\\?&]utm_medium=([^&#]*)').exec(window.location.href);
    if (((utm_medium != null) && (utm_medium[1] != null) && utm_medium[1].toLowerCase() === 'email') || (Cookie.get('_tpmed') === 'email')) {
      return true;
    } else {
      return false;
    }
  };

  SubscriptionsUI.prototype._skip_subscription_ui = function() {
    if (new RegExp('[\\?&]z=skip').test(window.location.href)) {
      return true;
    }
  };

  _is_sub_str = function(string, subStr) {
    return string.toUpperCase().indexOf(subStr.toUpperCase()) > -1;
  };

  SubscriptionsUI.prototype._is_bot = function() {
    var i, len, userAgent, userAgentHeader;
    userAgentHeader = navigator.userAgent;
    if (userAgentHeader) {
      for (i = 0, len = USER_AGENTS.length; i < len; i++) {
        userAgent = USER_AGENTS[i];
        if (_is_sub_str(userAgentHeader, userAgent)) {
          return true;
        }
      }
    }
    return false;
  };

  SubscriptionsUI.prototype._get_page_info = function() {
    var page_info, ref, ref1;
    page_info = {};
    if (($('head').attr('data-app') != null) && $('head').attr('data-app').length > 0) {
      page_info.app = encodeURIComponent($('head').attr('data-app'));
    } else if (((typeof Optimize !== "undefined" && Optimize !== null ? (ref = Optimize.suiteData) != null ? ref.app : void 0 : void 0) != null) && (typeof Optimize !== "undefined" && Optimize !== null ? (ref1 = Optimize.suiteData) != null ? ref1.app.length : void 0 : void 0) > 0) {
      page_info.app = encodeURIComponent(Optimize.suiteData.app);
    }
    return page_info;
  };

  SubscriptionsUI.prototype._get_app_name = function() {
    var tmpAppName;
    tmpAppName = this._get_page_info().app;
    return appName = tmpAppName != null ? tmpAppName.toLowerCase() : null;
  };

  SubscriptionsUI.prototype._dismiss_subscribe_modal = function(container) {
    container.hide();
    return container.hideSpotlight && container.hideSpotlight();
  };

  SubscriptionsUI.prototype._get_doi_modal_and_show = function(overlayColor) {
    var jqxhr, now, url;
    url = '/app/subscriptions/doi';
    now = new Date();
    loadStartTime = now.getTime();
    return jqxhr = $.get(url, function(data) {
      var $container;
      now = new Date();
      loadCompleteTime = now.getTime();
      $container = $('<div id="subscribe_doi_modal_container" />');
      $container.css({
        "display": "none",
        "position": "fixed",
        "z-index": "9999"
      });
      $container.html(data);
      $(document.body).append($container);
      if ($('#no_doi').length > 0) {
        return;
      }
      return setTimeout((function() {
        var dlg_height, dlg_width, left, top;
        dlg_width = $container.width();
        dlg_height = $container.height();
        left = ($(window).width() - dlg_width) / 2;
        top = ($(window).height() - dlg_height) / 2;
        overlayColor = overlayColor != null ? overlayColor : "#eee";
        $container.css({
          top: top,
          left: left
        });
        $container.show();
        $container.spotlight({
          opacity: 0.7,
          color: overlayColor,
          exitEvent: "none"
        });
        now = new Date();
        if ((typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub : void 0) != null) {
          OptimizeSuite.TrackingHub.add("subscriptionDOIDialogShown", {
            goalType: "subscription",
            uiType: "modal-dialog",
            loadingLatency: loadCompleteTime - loadStartTime,
            totalLatency: now.getTime() - constructionTime
          });
        }
        return $('#doi_dlg').on("dismiss", function() {
          SubscriptionsUI._dismiss_subscribe_modal($container);
          Cookie.set("subscription_doi_dismissed", true, DOI_DISMISS_LIFE_IN_SECONDS);
          if ((typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub : void 0) != null) {
            return OptimizeSuite.TrackingHub.add("subscriptionDOIDialogHidden", {
              goalType: "subscription",
              uiType: "modal-dialog"
            });
          }
        });
      }), 500);
    });
  };

  return SubscriptionsUI;

})();

window.SubscriptionsUI = new SubscriptionsUI();

SubscriptionsUI.increment_visited_cookie();

if (window.SubscriptionsUI._should_show_doi()) {
  window.SubscriptionsUI._get_doi_modal_and_show('#333');
  return;
}

//# sourceMappingURL=data:application/json;base64,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
